module.exports = __webpack_public_path__ + "img/649-be0d07.png";